import { useQuery } from '@tanstack/react-query';

import { AllowedTimes } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership/:membershipId/allowed-times/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
    membershipId: string;
}
const queryFn = ({ parkingId, membershipId, ...params }: DTO): Promise<ListResponseSmartParkAPI<AllowedTimes>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, membershipId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_MEMBERSHIP_ALLOWED_TIMES_RESOURCE, useQueryHook as useListMembershipAllowedTimes };
